













import { Component, Vue, Provide } from "vue-property-decorator";
const ExamineDetailMX = () => import("./view/examineDetailMX/index.vue");
const CustomerInformationMX = () => import("./view/customerInformationMX/index.vue");

@Component({
  name: "auditDetail",
  components: { ExamineDetailMX, CustomerInformationMX },
})
export default class auditDetail extends Vue {
  @Provide() private activeName: string = "first";
  private handleClick(tab: any, event: any) {
    // 点击tab,缓存
    localStorage.setItem("tabPheneVerify", tab.name);
  }
  private created() {
    // 刷新页面获取缓存或者默认值
    this.activeName = localStorage.getItem("tabPheneVerify") || "first";
  }
  private destroyed() {
    // 页面销毁时,将缓存修改为默认值，以便第一次进入时查看默认选中tab
    localStorage.setItem("tabPheneVerify", "first");
  }
}
